module.exports = __webpack_public_path__ + "static/media/elgato.b556f1ed.png";